import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../store/action/user";
import useFetch from "../../_fetch";
import { Image, message, Modal } from "antd";
import { Button, Row, Col, Typography, Form, Input } from "antd";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import ReCAPTCHA from "react-google-recaptcha";
import logo from '../../../src/assets/images/AuslinkLogo.png';
import { identifyUser, trackEvent } from "../../utils/mixpanel";

const { Title } = Typography;

export default function SignIn({ setUserChange }) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const recaptchaRef = React.useRef(null);
  const [showV2, setShowV2] = useState(false);
  const [form] = Form.useForm();
  const [captchaReady, setCaptchaReady] = useState(false);

  let _fetch = useFetch();
  let navigate = useNavigate();

  const showModal = () => {
    recaptchaRef?.current?.reset();
    setOpen(true);
  };

  useEffect(() => {
    if (executeRecaptcha) {
      setCaptchaReady(true);
      setLoading(false);
    } else {
      setCaptchaReady(false);
      setLoading(true);
    }
  }, [executeRecaptcha]);



  const handleOk = async () => {

    let otp = document.getElementById("otpInput").value;
    setLoading(true);

    try {
      let url = `${process.env.REACT_APP_API_URL}/user/otp`;

      let res = await _fetch(url, {
        method: "POST",
        body: {
          email: window.email,
          otp,
        },
      });
      let resData = await res.json();
      if (resData.success) {
        dispatch(login({ ...resData.user }));
        setUserChange(resData?.user)
        identifyUser(resData?.user);
        trackEvent("Login", {
          "Email": resData?.user?.email,
          "First Name": resData?.user?.first_name,
          "Last Name": resData?.user?.last_name,
          "Role": resData?.user?.role
        })
      } else {

        message.error(resData.message);
      }
    } catch (e) {
      console.error("otp submit post failed", e);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    recaptchaRef.current.reset();
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  const onChange = () => {
    console.log("recaptcha checked");
  };

  const _login = async (values) => {
    let result = null;

    try {
      let recaptchaToken = null;
      // Get reCAPTCHA token based on version
      if (showV2) {
        // Handle reCAPTCHA V2
        if (recaptchaRef.current) {
          recaptchaToken = recaptchaRef.current.getValue();
        } else {
          console.error("Recaptcha V2 is not available yet.");
          message.error(
            "reCAPTCHA is still loading. Please try again in a moment."
          );
          return;
        }
      } else {
        // Handle reCAPTCHA V3
        if (!executeRecaptcha) {
          console.error("Recaptcha V3 is not ready yet");
          message.error(
            "reCAPTCHA is still loading. Please try again in a moment."
          );
          return;
        }
        recaptchaToken = await executeRecaptcha("login");
      }

      setLoading(true);

      const body = {
        email: values.email,
        password: values.password,
        showV2,
        recaptchaToken,
      };

      let res = await _fetch(`${process.env.REACT_APP_API_URL}/user/login`, {
        method: "POST",
        body,
      });

      result = await res.json();


      if (result.success) {
        message.success("OTP Sent to your Email");
        window.email = values.email;
        showModal();
      } else {
        if (showV2 && result.openV2) {
          console.log("Recaptcha V2 required, no alert");
        } else {
          recaptchaRef?.current?.reset();
          if (result.error === "Recaptcha token score below 1") {
            console.log(result.error)
          }
          else message.error(result.error || result.response || result.message);
        }
      }
    } catch (err) {
      recaptchaRef?.current?.reset();
      console.error("Login error:", err);
      message.error("You are offline, please check your network connection.");
    } finally {
      if (result?.openV2) {
        setShowV2(true);
      }
      setLoading(false);
    }
  };

  const heading = process.env.REACT_APP_NAME;

  return (
    <>
      <div className="d-flex justify-content-center align-items-center">
        <Image src={logo}
          height={50}
          width={70}
        />
        <span>{heading}</span>
      </div>
      <Modal
        width={200}
        destroyOnClose
        open={open}
        title="Enter OTP"
        onOk={form.submit}
        onCancel={handleCancel}
        centered
        footer={[
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Submit
          </Button>,
        ]}
      >
        <Form form={form} onFinish={handleOk}>
          <Input id="otpInput" label="otp" />
        </Form>
      </Modal>

      <Row gutter={[24, 0]} justify="space-around">
        <Col
          xs={{ span: 24, offset: 0 }}
          lg={{ span: 10, offset: 2 }}
          md={{ span: 12 }}
        >
          <Title className="mb-15">Sign In</Title>
          <Title className="font-regular text-muted" level={5}>
            Enter your email and password to sign in
          </Title>
          <Form
            onFinish={_login}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            className="row-col"
            name="login"
          >
            <Form.Item
              className="username"
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your email!",
                },
              ]}
            >
              <Input
                placeholder="Email" type="email" />
            </Form.Item>

            <Form.Item
              className="username"
              style={{ marginBottom: "5px" }}
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input placeholder="Password" type="password" />
            </Form.Item>

            <Button
              type="link"
              className="mb-3"
              onClick={() => navigate("/auth/forgot-password")}
            >
              Forgot Password?
            </Button>
            {showV2 && (
              <Form.Item>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  isolated={true}
                  size="normal"
                  sitekey={process.env.REACT_APP_RECAPTCHAV2_SITEKEY}
                  onChange={onChange}
                />
              </Form.Item>
            )}
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
                loading={loading}
                disabled={!captchaReady}
              >
                SIGN IN
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
}
